import React from 'react';
import './InventoryBottomBar.css';

/**
 * Persistent bottom bar for Inventory screens.
 *
 * Props:
 *   onAdd    — callback when + is tapped (null to hide)
 *   onSave   — callback when Save is tapped (optional, detail screen only)
 *   saving   — boolean, disables Save and shows "Saving..." (optional)
 *   onSearch — callback when search is tapped (null to hide)
 */
export default function InventoryBottomBar({ onAdd, onSave, saving, onSearch }) {
  return (
    <div className="inv-bottom-bar">
      {onAdd ? (
        <button className="inv-bb-btn" onClick={onAdd} aria-label="Add tool">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M11 4V18M4 11H18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
          </svg>
        </button>
      ) : <span />}
      {onSave && (
        <button className="inv-bb-save" onClick={onSave} disabled={saving} aria-label="Save">
          {saving ? 'Saving...' : 'Save'}
        </button>
      )}
      {onSearch ? (
        <button className="inv-bb-btn" onClick={onSearch} aria-label="Search tools">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="9" cy="9" r="6" stroke="currentColor" strokeWidth="2" />
            <path d="M14 14L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      ) : <span />}
    </div>
  );
}
